import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {Nav} from "../components/shared/Nav";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {Unwrap} from "../components/pages/Unwrap/Unwrap";

/**
 * Container where logic for what should be displayed in plugin resides. Essentially
 * based on UI state, a logged in or logged out view is shown.
 */
@inject('UI_STORE')
@observer
export class Root extends React.Component<any, any> {

    public render(): any {
        return (

            <div>
                <Router>
                    <Nav/>
                    <div className="container">
                        <Switch>
                            <Route path="/unwrap/c/:code" component={Unwrap} />
                            <Route path="/unwrap/t/:puzzleId" component={Unwrap}/>
                            <Route path="/" component={Unwrap}/>
                        </Switch>
                    </div>
                </Router>

            </div>

        );
    }

}



